import { Search } from "lucide-react";

export const EMPTY_FILTERS = { q: "", category: "", material: "", style: "", sort: "newest" };

export function filterProducts(list, f) {
  const q = f.q.trim().toLowerCase();
  const mats = (p) => (Array.isArray(p.materials) ? p.materials : []);
  const out = (list || []).filter((p) =>
    (!q || [p.name, p.category, p.highlight, p.description, ...mats(p), ...(p.style_tags || [])].join(" ").toLowerCase().includes(q)) &&
    (!f.category || p.category === f.category) &&
    (!f.material || mats(p).includes(f.material)) &&
    (!f.style || (p.style_tags || []).includes(f.style)));
  const by = {
    newest: (a, b) => (b.created_at || "").localeCompare(a.created_at || ""),
    oldest: (a, b) => (a.created_at || "").localeCompare(b.created_at || ""),
    name: (a, b) => (a.name || "").localeCompare(b.name || ""),
    category: (a, b) => (a.category || "").localeCompare(b.category || ""),
  }[f.sort];
  return by ? [...out].sort(by) : out;
}

const sel = "bg-black/30 gold-border rounded-xl px-2.5 py-2 text-xs text-slate-100 focus:outline-none min-w-0";

export default function ProductFilters({ f, setF, tax, prefix = "lib" }) {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="space-y-2" data-testid={`${prefix}-filters`}>
      <div className="relative">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <input value={f.q} onChange={set("q")} placeholder="Search products…" className="w-full bg-black/30 gold-border rounded-xl pl-9 pr-3 py-2.5 text-sm text-slate-100 focus:outline-none" data-testid={`${prefix}-search`} />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <select value={f.category} onChange={set("category")} className={sel} data-testid={`${prefix}-filter-category`}>
          <option value="">All categories</option>
          {tax.categories.map((c) => <option key={c}>{c}</option>)}
        </select>
        <select value={f.material} onChange={set("material")} className={sel} data-testid={`${prefix}-filter-material`}>
          <option value="">All materials</option>
          {tax.materials.map((c) => <option key={c}>{c}</option>)}
        </select>
        <select value={f.style} onChange={set("style")} className={sel} data-testid={`${prefix}-filter-style`}>
          <option value="">All styles</option>
          {tax.styles.map((c) => <option key={c}>{c}</option>)}
        </select>
        <select value={f.sort} onChange={set("sort")} className={sel} data-testid={`${prefix}-sort`}>
          <option value="newest">Newest first</option>
          <option value="oldest">Oldest first</option>
          <option value="name">Name A–Z</option>
          <option value="category">Category</option>
        </select>
      </div>
    </div>
  );
}
